console.log("ENV ->", process.env.NODE_ENV)

export default {
    isDev: process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'functions',
    useFunctionsEmulator: false,
    getLocation: () => window.location.origin,
}